// import api from '@/api/common'
//  store.dispatch('customerValue')
const state = {
  customerValue: [], // 客户价值

}
const getters = {
  getCustomerValue: state => {
    return state.customerValue
  }

}

const mutations = {
  customerValue (state, list) {
    state.customerValue = list
  },
  
}

const actions = {
  customerValue ({ commit }) {
    commit('customerValue', [{ id: 1, name: '张三' }, { id: 2, name: '李四' }])
    // api.customerValueList()
    //   .then(list => (commit('customerValue', list)))
  },
  
}

export default {
  getters,
  state,
  mutations,
  actions
}

// 根据status id 获取对应的状态文字
export function getStatusText (status = 0) {
  const item = state.taskStatus.find(s => s.id === status)
  return item
    ? item.name
    : ''
}
